import useFetchApi from "@/api/hooks/useFetchApi";
import BreadCrumb from "@/components/BreadCrumb";
import Loader from "@/components/Loader/loader";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const ProductDetail: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const [breadcrumbChild, setBreadcrumbChild] = useState<string>("");

    const {
        data: productDetail,
        isLoading,
        error,
    } = useFetchApi({
        url: `/v1/gp/67850933e23ada9e6aa61f3c/tr/${id}/detail`,
        service: "CMS_PROC",
        options: {
            refreshInterval: 0,
            revalidateOnFocus: false,
        },
    });

    useEffect(() => {
        if (productDetail?.title) {
            setBreadcrumbChild(productDetail.title);
        }
    }, [productDetail]);

    if (isLoading) {
        return <Loader />;
    }

    if (error) {
        return <div>Bir hata oluştu: {error.message}</div>;
    }

    if (!productDetail) {
        return <div>Veri bulunamadı.</div>;
    }

    return (
        <>
            <BreadCrumb title={breadcrumbChild} parent="Ürünler" child="" />
            <section className="ls section_padding_145 service_single">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12 margin_0">
                            <div className="row">
                                <div className="col-lg-3 col-md-4">
                                    <div className="teaser">

                                        <div className={productDetail.image ? "" : "main_bg_color2 size_huge round overlapped-icon"}>
                                            <div style={{
                                                objectFit: "contain", height: "128px", display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                margin: "0 auto",
                                                position: "absolute",
                                                marginTop: "40px",
                                                marginLeft: "48px"
                                            }}>
                                                <img
                                                    src={
                                                        productDetail.image ||
                                                        productDetail.icon ||
                                                        "https://gunes-gaz.b-cdn.net/%C3%BCr%C3%BCnler/production.png"
                                                    }
                                                    style={
                                                        productDetail.icon
                                                            ? {

                                                            }
                                                            : {
                                                                objectFit: "contain", height: "250px", marginLeft: "-60px", marginTop: "20px"
                                                            }
                                                    }
                                                    alt={productDetail.title || "Ürün"}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-9 col-md-8">
                                    <h4 className="text-uppercase">{productDetail.title}</h4>
                                    <hr className="divider_2_30 left main_bg_color" />
                                    <p
                                        className="bottommargin_10"
                                        dangerouslySetInnerHTML={{ __html: productDetail.content }}
                                    ></p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-sm-12">
                                    {productDetail?.ozellikleri && (
                                        <p dangerouslySetInnerHTML={{ __html: productDetail.ozellikleri }}></p>
                                    )}
                                    {productDetail?.urun_gami && (
                                        <p dangerouslySetInnerHTML={{ __html: productDetail.urun_gami }}></p>
                                    )}
                                    {productDetail?.kullanim_alani && (
                                        <p dangerouslySetInnerHTML={{ __html: productDetail.kullanim_alani }}></p>
                                    )}
                                    {productDetail?.depolama && (
                                        <p dangerouslySetInnerHTML={{ __html: productDetail.depolama }}></p>
                                    )}
                                    {productDetail?.tehlike_aciklamasi && (
                                        <p dangerouslySetInnerHTML={{ __html: productDetail.tehlike_aciklamasi }}></p>
                                    )}
                                    {productDetail?.acil_durum && (
                                        <p dangerouslySetInnerHTML={{ __html: productDetail.acil_durum }}></p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ProductDetail;
